import styled from "styled-components";
import { AdminMenu } from "./AdminMenu";
import YLLWLOGO from "../../assets/Yllw_Inventory.svg";
import { Typography } from "@mui/material";
import { SoecoButton } from "../../components/SoecoButton";
import { useRef, useEffect } from "react";

export const Admin = () => {
    const headingRef = useRef<HTMLHeadingElement>(null);
    useEffect(() => {
        headingRef.current?.focus();
        setTimeout(() => {
            headingRef.current?.blur();
        }, 0);
    }, []);
    return (
        <AdminPageWrapper>
            <Logo src={YLLWLOGO} />
            <Typography
                color="#8c8c8c"
                fontWeight={500}
                fontSize={14}
                marginTop={"2px"}
                sx={{ fontFamily: "Inter, sans-serif" }}
                ref={headingRef}
                component="h1"
                variant="h1"
                tabIndex={0}
            >
                {"Admin"}
            </Typography>
            <AdminMenu />
            <ButtonWrapper>
                <SoecoButton fullWidth color="warning" link="/">
                    Back
                </SoecoButton>
            </ButtonWrapper>
        </AdminPageWrapper>
    );
};
const ButtonWrapper = styled.div`
    margin-bottom: -100px;
    width: 80%;
`;
const AdminPageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 80vh;
    justify-content: center;
    align-items: center;
`;
const Logo = styled.img`
    // margin-bottom: 25%;
    margin-top: 25px;
    height: 25px;
    width: 120px;
`;
